import { Dialog } from 'primereact/dialog'
import { FC, useEffect, useState } from 'react'
import CreateGifModal, { GifCaseOption } from './CreateGifModal'
import GifPlayerPanel from './GifPlayerPanel'

type GifPlayerScreenProps = {
  isOpen: boolean
  onClose: () => void
  /** Cases to display as side-by-side players (first two are shown). */
  cases: GifCaseOption[]
}

/**
 * Full-screen side-by-side animated player for comparing case image sequences,
 * with optional linked playback and a shortcut into the Create Animated GIF flow.
 */
const GifPlayerScreen: FC<GifPlayerScreenProps> = ({ isOpen, onClose, cases }) => {
  const panelCases = cases.slice(0, 2)

  const [linked, setLinked] = useState(true)
  const [sharedIndex, setSharedIndex] = useState(0)
  const [sharedPlaying, setSharedPlaying] = useState(false)
  const [showGifModal, setShowGifModal] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setSharedIndex(0)
      setSharedPlaying(false)
      setShowGifModal(false)
    }
  }, [isOpen])

  const isLinked = linked && panelCases.length === 2

  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      header="Player"
      style={{ width: '95vw', height: '90vh' }}
      maximizable
      modal
      pt={{ content: { className: 'p-0 flex flex-col' } }}>
      <div className="flex flex-1 min-h-0 divide-x divide-gray-200 dark:divide-gray-700">
        {panelCases.map(c => (
          <GifPlayerPanel
            key={c.systemRunId}
            systemRunId={c.systemRunId}
            caseName={c.caseName}
            runName={c.runName}
            onGenerateGif={() => setShowGifModal(true)}
            linked={panelCases.length === 2 ? isLinked : undefined}
            onToggleLink={panelCases.length === 2 ? () => setLinked(prev => !prev) : undefined}
            index={isLinked ? sharedIndex : undefined}
            onIndexChange={isLinked ? setSharedIndex : undefined}
            playing={isLinked ? sharedPlaying : undefined}
            onPlayingChange={isLinked ? setSharedPlaying : undefined}
          />
        ))}
        {panelCases.length === 0 && (
          <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
            No cases selected.
          </div>
        )}
      </div>

      <CreateGifModal isOpen={showGifModal} onClose={() => setShowGifModal(false)} cases={cases} />
    </Dialog>
  )
}

export default GifPlayerScreen
